import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import _ from "lodash";

import DefaultDataGrid from "modules/5_view_helpers/web/DefaultDataGrid";
import columns from "./columns";

import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";

import { getGlobalSettings } from "../actions";

function mapStateToProps(state) {
  return {
    global_settings: state.global_settings,
  };
}

// usage: <GlobalSettingsIndex category="QA" returnUrl="/qa/settings" />
const GlobalSettingsIndex = (props) => {
  const { category, returnUrl, title } = props;

  useEffect(() => {
    props.getGlobalSettings(category);
  }, [category]);

  const { global_settings } = props;

  const readRole = HasRole({ resource_type: "GlobalSetting", name: ["read", "update", "moderator"] });
  const updateRole = HasRole({ resource_type: "GlobalSetting", name: ["update", "moderator"] });

  const settings = _.filter(global_settings, (s) => !category || s.category === category);

  if (!readRole) {
    return <NotAuthorized />;
  }

  return (
    <Card>
      <CardHeader>
        <Row>
          <Col>
            <h3>{title || (category ? `${category} Settings` : "Global Settings")}</h3>
          </Col>
        </Row>
      </CardHeader>

      <CardBody>
        <Row className="mt-2">
          <Col>
            <DefaultDataGrid columns={columns(updateRole, returnUrl)} data={settings} />
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default connect(mapStateToProps, { getGlobalSettings })(GlobalSettingsIndex);
